import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/config';
import { AppService } from 'src/app/service/app.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { DatatableService } from 'src/app/service/datatable.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
declare var $: any;
pdfMake.vfs = pdfFonts.vfs;

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent {
  config: any = config;
  users: any[] = [];
  dtOptions: any;
  dtTrigger: Subject<any> = new Subject<any>();
  viewUser: any = {};
  searchUserForm: FormGroup;
  entityTypeData: any;
  keyword: string = "name";
  userDetails: any = {};
  showDatatable: boolean = true;
  access: any = {};
  menuCode: string = 'userList';

  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;

  constructor(private appService: AppService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private titleService: Title,
    private spinner: NgxSpinnerService,
    private userDetailsService: UserDetailsService,
    private route: ActivatedRoute,
    private dataTableService: DatatableService
  ) { }

  get f() { return this.searchUserForm.controls; }

  ngOnInit(): void {
    this.titleService.setTitle('Access Management');
    this.entityTypeData = this.config.data.entityTypeData;
    this.userDetails = this.userDetailsService.getUserDetails();
    this.access = this.userDetailsService.checkUserAccess(this.menuCode);
  
    if (this.access === undefined || this.access.isAccessAllowed != 'Y') {
      this.router.navigate(['/']);
      this.toastr.error("Unauthorize to access this page !");
    }
    $('[data-toggle="popover"]').popover();
  }

  ngAfterViewInit() {
    this.getUserList();
    // $('.selectpicker').selectpicker();
  }

  getUserList() {
    this.showDatatable=false;
    this.spinner.show();
    this.appService.getUserList().pipe(
      catchError((error: any) => {
        this.spinner.hide();
        this.users = [];
        this.dataTableService.setDatatable("userAccessList", 7, 10, [10, 25, 50, 100]);
        this.showDatatable=true;
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.statusCode == 200) {
          this.users = response.data;
          this.userDetailsService.addUsers(this.users);
          this.dataTableService.setDatatable("userAccessList", 7, 10, [10, 25, 50, 100]);
          this.showDatatable=true;
        } else {
          this.users = [];
          this.dataTableService.setDatatable("userAccessList", 7, 10, [10, 25, 50, 100]);
          this.showDatatable=true;
        }
      }
    );
  }

  viewUserData(id: number) {
    this.viewUser = this.users.filter(user => user.userId == id)[0];
  }

  editUserAccessData(id: number) {
    this.router.navigate(['accessMapping'], { "queryParams": { "id": id }, relativeTo: this.route, skipLocationChange: true });
  }

  editUserData(id: number) {
    this.router.navigate(['add-user'], { "queryParams": { "id": id }, relativeTo: this.route, skipLocationChange: true });
  }

  clearSearch() {
    this.dataTableService.setDatatable("userAccessList", 7, 10, [10, 25, 50, 100]);
  }

  reset() {
    this.searchUserForm.reset();
  }

  ngOnDestroy(): void {
    this.dtTrigger?.unsubscribe();
  }
}
